import React from 'react';
import RichTextEditor from '../../../../ui/RichTextEditor';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export default function SummaryEditor({ value, onChange }: Props) {
  return (
    <div>
      <RichTextEditor
        label="Professional Summary"
        value={value}
        onChange={onChange}
        placeholder="Write a brief summary of your professional background, key achievements, and career goals..."
        rows={8}
        required
      />
      <p className="mt-2 text-sm text-gray-500">
        Aim for 3-5 sentences that capture your professional identity and value proposition.
      </p>
    </div>
  );
}